document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('bundle-form');
    const productContainer = document.getElementById('product-selection-container');
    const previewContainer = document.getElementById('selected-products-preview');
    const previewContainerMb = document.getElementById('selected-products-sticky');
    const addToCartButton = document.getElementById('add-to-cart-btn');
    const addToCartRichText = document.getElementById('add-to-cart-rich-text');
    const maxProducts = 5; // Maximum quantity of items

    // The merchant's custom button text (set in the theme customizer) — used to restore
    // the button label after an error or a failed validation, instead of a hardcoded string.
    const defaultButtonText = (addToCartButton.dataset.defaultText || addToCartButton.textContent || 'Add to cart').trim();

    // Define your products as a JSON array
    const products = [
      /* {
            "title": "Powder",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/B00CB1QP46.MAIN_c3ba5dc0-3b00-4194-9059-786793435a48.webp",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Image-4_1.webp?v=1763426468"
        }, */
         {
            "title": "Pure Stevia Extract",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/1.25oz_Powder_Image_1_cdf4cc42-96c3-4012-a15d-039ac26a4ba2.jpg?v=1777542192",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/back_stevia.png?v=1777542192",
            "sku": "LA-KGEX-51NT",
            "variantId": "52971693670679"
        },
        {
            "title": "Plain",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Plain.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Plain_Hover.jpg",
            "sku": "Plain Child",
            "variantId": "52759476764951"
        },
      {
            "title": "Vanilla",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Vanilla.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Vanilla_Hover.jpg",
            "sku": "5T-TWSH-MKM0",
            "variantId": "52759476797719"
        },
         {
            "title": "Caramel",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Caramel.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Caramel_Hover.jpg",
            "sku": "U1-GTO9-GJQ0",
            "variantId": "52759476830487"
        },
        {
            "title": "Hazelnut",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Hazelnut.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Hazelnut_Hover.jpg",
            "sku": "2K-W6NV-NQ5B",
            "variantId": "52759476863255"
        },
     {
         "title": "Maple",
             "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Maple.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Maple_Hover.jpg",
           "sku": "6A-0EN4-CJWI",
             "variantId": "52759476896023"
         },
        {
            "title": "Pumpkin Spice",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Pumpkin_Spice.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Pumpkin_Spice_Hover.jpg",
            "sku": "K3-4X4T-N4J4",
            "variantId": "52759476928791"
        },
         {
             "title": "Butterscotch",
             "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Butterscotch.jpg",
             "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Butterscotch_Hover.jpg",
             "sku": "ID-EWCO-9X99",
             "variantId": "52759476961559"
         },
        {
            "title": "Irish Cream",
            "image": "https://steviaselect.com/cdn/shop/products/mainirishcream.jpg?v=1676508776&width=535",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Irish_Cream_Hover.jpg",
            "sku": "A1-QYCO-0MHW",
            "variantId": "52759476994327"
        },
        {
            "title": "Butter Pecan",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Butter_Pecan.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Butter_Pecan_Hover.jpg",
            "sku": "SS-SLF-BP",
            "variantId": "52759477027095"
        },
       {
            "title": "Dark Chocolate",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Dark_Chocolate.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Dark_Chocolate_Hover.jpg",
            "sku": "8A-LDJ0-8M1D",
            "variantId": "52759477059863"
        },
        {
            "title": "Root Beer",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Root_Beer.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Root_Beer_Hover.jpg",
            "sku": "JW-860A-JS8D",
            "variantId": "52759477092631"
        },
        {
            "title": "Raspberry",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Raspberry.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Raspberry_Hover.jpg",
            "sku": "FV-WUN4-7IE3",
            "variantId": "52759477125399"
        },
        {
            "title": "Black Cherry",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Black_Cherry.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Black_Cherry_Hover.jpg",
            "sku": "XP-OXV5-XNO4",
            "variantId": "52759477158167"
        },
        {
            "title": "English Toffee",
            "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Toffee.jpg",
            "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Toffee_Hover.jpg",
            "sku": "MR-F91O-C5Y6",
            "variantId": "52759477190935"
        },
      {
            "title": "Coconut",
             "image": "https://cdn.shopify.com/s/files/1/2779/7760/files/Coconut.jpg",
             "image2": "https://cdn.shopify.com/s/files/1/2779/7760/files/Coconut_Hover.jpg",
             "sku": "C0-TXCS-YV78",
             "variantId": "52759477223703"
         }
    ];

    // Function to display the products
    function displayProductSelections() {
        products.forEach(product => {
            const productItem = document.createElement('div');
            productItem.className = 'product-item';
            productItem.innerHTML = `
                <div class="thumb test">
                    <img src="${product.image}" alt="${product.title}" loading="lazy" width="200" height="200">
                    <img class="img2" src="${product.image2}" alt="${product.title}" loading="lazy" width="200" height="200">
                </div>
                <h4>${product.title}</h4>
                <div class="actions">
                    <div class="input-qty-wrapper" style="display:none;">
                        <button class="minus-button" type="button">-</button>
                        <input type="number" class="quantity-input" value="0" min="0" max="5" disabled>
                        <button class="plus-button" type="button">+</button>
                    </div>
                    <button class="add-item-btn" type="button">+ Add</button>
                </div>
            `;
            productItem.setAttribute('data-product-title', product.title);
            productItem.setAttribute('data-product-sku', product.sku);
            productContainer.appendChild(productItem);
        });
    }

    // Display the product selections on page load
    displayProductSelections();

    // Function to initialize empty slots as hidden inputs and placeholders in preview
    function createEmptySlots() {
        previewContainer.innerHTML = ''; // Clear any previous visual preview slots
        // form.querySelectorAll('.dynamic-property').forEach(input => input.remove()); // Clear previous hidden inputs

        for (let i = 1; i <= maxProducts; i++) {
            // Visual placeholder in the preview container
            const emptySlot = document.createElement('div');
            emptySlot.className = 'selected-product-item empty-slot';
            emptySlot.innerHTML = '<div class="thumb"></div>';
            previewContainer.appendChild(emptySlot);
        }
    }

    // Initialize slots on page load
    createEmptySlots();

    function addItemSlot(productId) {

        const product = products.find(p => p.title === productId); // Get the product by ID
        const slots = previewContainer.querySelectorAll('.selected-product-item');

        for (let index = 0; index < slots.length; index++) {
            const slot = slots[index];
            // Check if the slot is empty
            if (slot.classList.contains('empty-slot')) {
                // Create elements for the preview
                slot.innerHTML = ''; // Clear existing content

                const imgElementWrap = document.createElement('div');
                imgElementWrap.className = 'thumb';

                const imgElement = document.createElement('img');
                imgElement.src = product.image;
                imgElement.alt = product.title;


                const titleElement = document.createElement('h5');
                titleElement.innerText = product.title;

                // Append the image and title to the slot
                imgElementWrap.appendChild(imgElement);
                slot.appendChild(imgElementWrap);
                slot.appendChild(titleElement);

                // Create the remove button and display it
                const removeButton = document.createElement('button');
                removeButton.className = 'remove-slot-btn';
                removeButton.type = 'button';
                removeButton.innerText = 'x';
                slot.appendChild(removeButton); // Append the remove button to the slot

                // Store product data on the slot element for cart submission
                slot.setAttribute('data-variant-id', product.variantId);
                slot.setAttribute('data-product-title', product.title);

                // Remove the empty-slot class since the slot is now filled
                slot.classList.remove('empty-slot');

                break; // Exit the loop after filling a slot
            }

        }

    }

    function removeItemSlot(productId) {

        const filledSlots = Array.from(previewContainer.querySelectorAll('.selected-product-item:not(.empty-slot)')).reverse();

        for (const slot of filledSlots) {

            if (slot.getAttribute('data-product-title') == productId) {
                // Reset the slot to empty
                slot.innerHTML = '<div class="thumb"></div>';
                slot.classList.add('empty-slot');
                slot.removeAttribute('data-variant-id');
                slot.removeAttribute('data-product-title');

                // Break out of the loop if needed
                break;
            }
        }

    }

    // Event listeners for Add Flavor, Plus, and Minus buttons
    productContainer.addEventListener('click', function (e) {
        const target = e.target;

        if (target.classList.contains('add-item-btn')) {

            if(countSelectedItems() >= maxProducts) {
                previewContainer.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'start', 
                    inline: 'nearest' 
                });
                return;
            }

            const productItem = target.closest('.product-item');
            const productId = productItem.getAttribute('data-product-title');
            const quantityInput = productItem.querySelector('.quantity-input');

            // Set quantity to 1 if adding the item
            quantityInput.value = parseInt(quantityInput.value) + 1 || 1;

            addItemSlot(productId);


        } else if (target.classList.contains('plus-button')) {

            if(countSelectedItems() >= maxProducts) {
                previewContainer.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'start', 
                    inline: 'nearest' 
                });
                return;
            }

            const productItem = target.closest('.product-item');
            const productId = productItem.getAttribute('data-product-title');
            const quantityInput = productItem.querySelector('.quantity-input');

            quantityInput.value = parseInt(quantityInput.value) + 1 || 1; 

            addItemSlot(productId);


        } else if (target.classList.contains('minus-button')) {

            const productItem = target.closest('.product-item');
            const productId = productItem.getAttribute('data-product-title');
            const quantityInput = productItem.querySelector('.quantity-input');

            quantityInput.value = Math.max(0, (parseInt(quantityInput.value) || 0) - 1); // Decrement quantity

            removeItemSlot(productId);
        }

        updateFormView();

    });


  form.addEventListener('click', function (e) {
        const target = e.target;

        if (target.classList.contains("remove-slot-btn")) {
            e.preventDefault();

            const slot = target.closest('.selected-product-item');
            const parent = slot.parentNode;
            const index = Array.from(parent.children).indexOf(slot);
            const productVal = slot.getAttribute('data-product-title');
            const productItem = productContainer.querySelector('.product-item[data-product-title="'+productVal+'"]');
            const quantityInput = productItem.querySelector('.quantity-input');

            quantityInput.value = Math.max(0, (parseInt(quantityInput.value) || 0) - 1); // Decrement quantity

            slot.innerHTML = '<div class="thumb"></div>';
            slot.classList.add('empty-slot'); // Mark it as an empty slot again
            slot.removeAttribute('data-variant-id');
            slot.removeAttribute('data-product-title');

            const origSlot = previewContainer.children[index];
            origSlot.innerHTML = '<div class="thumb"></div>';
            origSlot.classList.add('empty-slot'); // Mark it as an empty slot again
            origSlot.removeAttribute('data-variant-id');
            origSlot.removeAttribute('data-product-title');

            updateFormView();
        }


    });


    function countSelectedItems() {
        return previewContainer.querySelectorAll('.selected-product-item:not(.empty-slot)').length;
    }


    function updateFormView() {

        const productItems = productContainer.querySelectorAll('.product-item');

        for (const productItem of productItems) {

            const quantityInput = productItem.querySelector('.quantity-input');
            const quantity = parseInt(quantityInput.value) || 0;

            // Toggle visibility of input wrapper and add button
            const addButton = productItem.querySelector('.add-item-btn');
            const inputQtyWrapper = productItem.querySelector('.input-qty-wrapper');

            if (quantity > 0) {
                inputQtyWrapper.style.display = 'flex';
                addButton.style.display = 'none';
            } else {
                inputQtyWrapper.style.display = 'none';
                addButton.style.display = 'block';
            }

            updateAddToCartButtonVisibility();

        }

      const clonedPreview = previewContainer.cloneNode(true);
      previewContainerMb.innerHTML = '';
      // previewContainerMb.innerHTML = clonedPreview.innerHTML;
      previewContainerMb.appendChild(clonedPreview);
      const clonedBtn = addToCartButton.cloneNode(true);
      previewContainerMb.appendChild(clonedBtn);
      clonedBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (typeof submitBundle === 'function') submitBundle(e);
          else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });


    }

// Function to check visibility of the element
function checkVisibility() {
    const rect = previewContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight; // Total height of the document
    const scrollY = window.scrollY + windowHeight; // Current scroll position + viewport height

    // Check if the element is at the top or bottom of the viewport
    if (scrollY >= documentHeight || window.scrollY == 0) {
        previewContainerMb.style.display = "none"; // Show the element
    }else if (rect.top < 0 || rect.bottom > windowHeight || scrollY >= documentHeight) {
        previewContainerMb.style.display = "block"; // Hide the element
    } else {
        previewContainerMb.style.display = "none"; // Show the element
    }
}

// Listen for the scroll event
window.addEventListener("scroll", checkVisibility);

// Also check visibility on page load
checkVisibility();

updateFormView(); //trigger init *********

    // Update visibility of the Add to Cart button based on selected items
    function updateAddToCartButtonVisibility() {
        if(countSelectedItems() >= maxProducts) {
            addToCartButton.style.display = 'block';
            if (addToCartRichText) addToCartRichText.style.display = 'block';
        } else {
            addToCartButton.style.display = 'none';
            if (addToCartRichText) addToCartRichText.style.display = 'none';
        }
    }

    // Handle bundle add-to-cart — AJAX multi-item (bundle + $0 flavor variants)
    function submitBundle(event) {
      if (event) event.preventDefault();

      const addToCartBtn = document.getElementById('add-to-cart-btn');
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      // 1. Get the main bundle variant ID
      const bundleVariantId = document.querySelector('input[name="id"]').value;

      // 2. Build quantity map from filled slots
      const flavorQuantities = {};
      const filledSlots = previewContainer.querySelectorAll('.selected-product-item:not(.empty-slot)');
      filledSlots.forEach(slot => {
          const vid = slot.getAttribute('data-variant-id');
          if (vid) flavorQuantities[vid] = (flavorQuantities[vid] || 0) + 1;
      });

      // Token links the bundle to its hidden flavor lines so we can cascade-delete orphans
      const bundleToken = 'bun_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

      // 3. Build items array — bundle product first
      const items = [{
          id: parseInt(bundleVariantId),
          quantity: 1,
          properties: { '_bundle_id': bundleToken, '_bundle_role': 'parent' }
      }];

      // 4. Add each selected flavor as a $0 line item
      // _bundle_unit_qty stores the per-bundle quantity, so we can scale children if the parent qty changes
      for (const [vid, qty] of Object.entries(flavorQuantities)) {
          if (!vid || isNaN(parseInt(vid))) {
              alert('A selected flavor is missing configuration. Please contact support.');
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = defaultButtonText;
              return;
          }
          items.push({
              id: parseInt(vid),
              quantity: qty,
              properties: {
                '_bundle_id': bundleToken,
                '_bundle_role': 'child',
                '_bundle_unit_qty': String(qty)
              }
          });
      }

      console.log('[bundle] submitting items:', items);

      // 5. POST to /cart/add.js
      fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
      })
      .then(response => {
          console.log('[bundle] /cart/add.js status:', response.status);
          if (!response.ok) return response.json().then(err => { throw err; });
          return response.json();
      })
      .then(data => {
          console.log('[bundle] /cart/add.js response:', data);

          // This store's cart drawer is driven by the Zipify OneClickUpsell (OCU) app,
          // not Shopify's native mini-cart — open it via its own custom event.
          document.dispatchEvent(new Event('ocu:cart:open'));
          window.dispatchEvent(new Event('ocu:cart:open'));

          addToCartBtn.disabled = false;
          addToCartBtn.textContent = defaultButtonText;
      })
      .catch(error => {
          console.error('[bundle] add-to-cart error:', error);
          alert((error && error.description) || 'Error adding bundle to cart. Please try again.');
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = defaultButtonText;
      });
    }

    addToCartButton.addEventListener('click', submitBundle);
    form.addEventListener('submit', submitBundle);

    // Delegated capture-phase listener so our handler runs FIRST regardless of any other intercepts
    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest && e.target.closest('#add-to-cart-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      submitBundle(e);
    }, true);

    // Capture-phase submit listener — catches Enter-on-input, programmatic submits,
    // and any other path that would otherwise post the bare parent variant to /cart/add
    document.addEventListener('submit', function (e) {
      const f = e.target;
      if (!f || f.id !== 'bundle-form') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      submitBundle(e);
    }, true);

    window.__bundleSubmit = submitBundle;
    console.log('[bundle] init complete — submitBundle attached to button + form + capture delegate');
});



  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="#product-selections-anchor"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('product-selections-anchor');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });